var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news",attrs:{"id":"news","name":"news"}},[_c('div',{staticClass:"top"},[_c('NavTop',{attrs:{"activeIndex":"2"}})],1),_c('div',{staticClass:"content"},[_vm._v(" 隐私协议 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }